import axios from "axios";

const instance = axios.create({
   baseURL:"/api",
   timeout:3500
})

instance.interceptors.request.use(
  config=>{
    // console.log("请求拦截器");
    // let token = localStorage.getItem("token");
    // if (token) {
    //     if (config.headers) {
    //         config.headers["Authorization"] = token
    //     }
    // }
    return config;
  }, err=>{
    Promise.reject(err)
  }
)
instance.interceptors.response.use(
    response=>{
      return  response
    },err=>{
        Promise.reject(err) 
    }
)
export default instance

